import * as d3 from 'd3-selection'

const descriptionLineHeight = 15 // each line

const bodyPadding = 4

/*
 * Positions the labels when we're showing the wide version of the process
 * chart.
 */
export default (selection, titleHeight) => {
  selection.each(function (d) {
    let container = d3.select(this)
                      .attr('transform', '')
      , stage = container.select('.stage-number')
      , radius = Math.min(45, d.height * .5) / 2

    stage.style('display', radius < 8 ? 'none' : '')
         .attr('transform', d => {
           let x = d.arrowWidth / 2
             , y = 0

           if (d.idx === 0) {
             // the first stage is centered directly between the top and bottom borders
             y = d.height / 2
           } else {
             // center between the tip above and bottom border
             // Store the y value so we can grab its position for positioning body
             y = d.tipHeight + (d.height - d.tipHeight) / 2
           }

           return `translate(${x}, ${y})`
         })

    stage.select('circle').attr('r', radius)
    stage.select('text').attr('font-size', radius * 1.5)

    // Now position the title and description
    let title = container.select('.title')
    title.classed('centered', false)
         .style('display', d => {
           // Only show if we have enough space
           return d.height < titleHeight * 2 ? 'none' : ''
         })
         .attr('width', d => d.extension * .8) // 80% of the space

    let availableSpace = d.height - bodyPadding * 2
      , showingTitle = title.size() && title.style('display') !== 'none'

    if (showingTitle) {
      availableSpace -= titleHeight
    }

    let description = container.select('.description')
      , descriptionHeight = 0

    if (availableSpace > descriptionLineHeight * 3) {
      descriptionHeight = descriptionLineHeight * 3 // Full space
    } else if (availableSpace > descriptionLineHeight * 2) {
      descriptionHeight = descriptionLineHeight * 2
    } else if (availableSpace > descriptionLineHeight) {
      descriptionHeight = descriptionLineHeight
    } else {
      descriptionHeight = 0
    }

    if (title.size() && title.style('display') === 'none') {
      descriptionHeight = 0 // Don't show description if we didn't have space for the title
    }

    description.style('display', descriptionHeight ? '' : 'none')
               .attr('height', descriptionHeight)
               .attr('width', d => d.extension * .8)

    // Position the title and description so they are centered
    let bodyHeight = 0

    if (showingTitle) {
      bodyHeight += titleHeight
    }
    if (description.size() && description.style('display') !== 'none') {
      bodyHeight += descriptionHeight
    }

    let bodyY = Math.max(0, d.height - bodyHeight) / 2

    title.attr('transform', d => {
            return `translate(${d.arrowWidth}, ${bodyY})`
          })

    description.attr('transform', d => {
                  return `translate(${d.arrowWidth}, ${bodyY + (showingTitle ? titleHeight : 0)})`
                })

    // Now position the value
    let value = container.select('.value')

    value.classed('centered', false)
         .style('display', '') // Always show
         .attr('width', d => d.extension * .2)
         .attr('transform', d => {
           return `translate(${(d.arrowWidth + d.extension - d.extension * .2) - 3}, ${bodyY})`
         })
  })
}
